import { Failure } from "../helpers/failure";
import { getClicks$ } from "../helpers/rxjs-helpers";
import { warn } from "../helpers/browserConsole";
import {
  LanguageService,
  TranslationTexts,
} from "../services/language-service";
import { Toast } from "toaster-js";

/**
 * Copies the current URL to the users clipboard when the user clicks a button with the following format
 *
 * <div class="ug-copy ug-copy-url"></div>
 * @param languageService
 */
export function SetupCopyToClipboardButtons(languageService: LanguageService) {
  const copyButtonClick$ = getClicks$(".ug-copy");
  copyButtonClick$.subscribe((copyButton) =>
    copyButtonClickHandler(copyButton, languageService.getTranslations())
  );
}

function copyButtonClickHandler(
  element: Element,
  translationTable: TranslationTexts
) {
  var value;
  if (element.classList.contains("ug-copy-url")) {
    value = getCurrentUrl();
  } else {
    // error
    Failure(
      "Invalid .ug-copy-url button: missing class that indicates value to be copied"
    );
  }

  // save value to clipboard
  writeValueToClipboard(value).then((success) => {
    if (success) {
      new Toast(translationTable.toast.linkCopy, Toast.TYPE_INFO, 3000);
    } else {
      new Toast(translationTable.toast.linkCopyError, Toast.TYPE_INFO, 3000);
    }
  });
}

function getCurrentUrl(): string {
  return window.location.href;
}

async function writeValueToClipboard(value: string): Promise<boolean> {
  try {
    const type = "text/plain";
    const blob = new Blob([value], { type });
    const data = [new ClipboardItem({ [type]: blob })];
    return await navigator.clipboard.write(data).then(
      () => {
        return true; // success
      },
      (err) => {
        warn("Clipboard write error: ", err);
        return false; // failure
      }
    );
  } catch (exception) {
    warn("Clipboard write error: ", exception);
    return false; // failure
  }
}
